// extracted by mini-css-extract-plugin
export var clouds = "clouds-module--clouds--11oeH";
export var AnimatedCloud = "clouds-module--AnimatedCloud--DCFWw";
export var c1 = "clouds-module--c1--1jYZZ";
export var c2 = "clouds-module--c2--E_UE1";
export var c3 = "clouds-module--c3--2xgKm";